import axios from "axios";
import { TOKEN_NAME, TOKEN_PREFIX } from "./CONSTANTS";
import { API_URL } from "./ENDPOINTS";
import { flattenErrors } from "utilities";

import axiosCancel from "axios-cancel";

axiosCancel(axios, {
  debug: false, // default
});

function getLang(): string {
  return document.documentElement.getAttribute("lang");
}

function addSlash(url) {
  // converts:
  // /url/endpoint
  //into:
  // /url/endpoint/
  // because python required slash at the end of url
  const arr = url.split("?");
  if (arr[0].charAt(arr[0].length - 1) !== "/") {
    arr[0] = arr[0] += "/";
    return arr[0] + (arr[1] || "");
  }
  return url;
}

function fetch({ url, method = "get", headers = {}, data, requestId, ...rest }) {
  if (["get", "post", "put", "delete", "patch"].indexOf(method.toLowerCase()) === -1) {
    console.error("invalid method " + method);
  }
  const token = window.localStorage && localStorage.getItem(TOKEN_NAME);
  let allHeaders = { "Accept-Language": getLang() };

  if (token) {
    // if user is logged in - add token to request headers
    allHeaders = { ...allHeaders, Authorization: TOKEN_PREFIX + token };
  }

  allHeaders = { ...allHeaders, ...headers };
  const endpoint = API_URL + addSlash(url);
  // get and delete takes two params, post and put takes three
  let axiosParams = {
    method,
    headers: allHeaders,
    url: endpoint,
    requestId: requestId || endpoint.split("?")[0],
    ...rest,
  };

  if (["post", "put", "patch"].indexOf(method.toLowerCase()) !== -1) {
    axiosParams.data = data;
  }

  return axios(axiosParams).then(
    ({ data, status }) => {
      return Promise.resolve({ payload: data, status });
    },
    function(err) {
      const canceled = axios.isCancel(err);
      if (canceled) {
        console.log("request canceled - found duplicate pending request");
        return Promise.reject({ isCanceled: true });
      }

      const error = {
        status: err.response ? err.response.status : err.request ? err.request.status : undefined,
        error: err.response
          ? typeof err.response.data === "object" ? flattenErrors(err.response.data) : {}
          : {},
      };
      if (error.error.detail) {
        error.error.message = error.error.detail;
      }

      if (error.error.non_field_error) {
        error.error.message = error.error.non_field_error;
      }

      if ([500, 512].find(el => el === error.status)) {
        error.error = {
          message: "Błąd serwera",
        };
      }
      if (error.status === 502 || error.status === 0) {
        error.error = {
          message:
            "Serwer nie odpowiada. Prawdopodobnie trwa wdrożenie nowej wersji oprogramowania. Spróbuj ponownie za chwilę.",
        };
      }

      if (!error.error.$any) {
        error.error.$any = error.error.message;
      }
      return Promise.reject(error);
    }
  );
}

export default fetch;



// WEBPACK FOOTER //
// ./src/apiMiddleware.js